import { until } from "@vueuse/core";

import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { useDialog } from "primevue/usedialog";
import { computed, ref } from "vue";

import TotpDialog from "@/components/Totp.vue";

export const useTotpDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));
    const authenticationSuccess = ref(false);

    /**
     * Opens dialog and returns when the dialog is closed with
     * the authenticationSuccess value.
     */
    const open = async (
        {
            enrollment,
            successCallback,
            failureCallback,
        }: {
            enrollment?: boolean;
            successCallback?: () => void;
            failureCallback?: () => void;
        } = {
            enrollment: false,
        }
    ) => {
        dialogRef.value = dialog.open(TotpDialog, {
            props: {
                header: "One-Time Password",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
                closable: !enrollment,
            },
            data: {
                enrollment,
                failureCallback: () => {
                    authenticationSuccess.value = false;
                    failureCallback?.();
                },
                successCallback: () => {
                    authenticationSuccess.value = true;
                    successCallback?.();
                },
            },
        });

        await until(isVisible).not.toBeTruthy();
        return authenticationSuccess.value;
    };

    return { open, isVisible };
};
